/**
 * check whether the browser support webp
 *
 * @return  {Promise.<Boolean>}
 */
export const checkWebp = () => {
  return new Promise(resolve => {
    const WebP = new Image()
    WebP.onload = WebP.onerror = () => {
      resolve(WebP.height === 1)
    }
    WebP.src =
      'data:image/webp;base64,UklGRiYAAABXRUJQVlA4IBoAAAAwAQCdASoBAAEAAAAMJaQAA3AA/v89WAAAAA=='
  })
}
